import { Box } from '@mui/material';
import { Sparkles } from 'lucide-react';
import useNavigationStore from 'src/store/navigation';
import { useSidekickTransition } from 'src/utils/navigation/use-sidekick-transition';
import { TransitionBar, TransitionBarSpark } from './sidekick-transition.styles';

/** Sidekick's old entry point; using it once moves the entry to the grouping tabs. */
export const SidekickTransitionBar = () => {
  const setActivePane = useNavigationStore((state) => state.setActivePane);
  const { showTransitionBar, completeTransition } = useSidekickTransition();

  if (!showTransitionBar) {
    return null;
  }

  return (
    <TransitionBar
      type="button"
      data-testid="sidekick-transition-bar"
      onClick={() => {
        completeTransition();
        setActivePane('sidekick');
      }}
    >
      <TransitionBarSpark>
        <Sparkles size={16} />
      </TransitionBarSpark>
      <Box component="span" flex={1} textAlign="left">
        Sidekick
      </Box>
    </TransitionBar>
  );
};
